import React from "react";
import { Divider } from "antd";
import { ApplicationCommission } from "./ApplicationCommission/ApplicationCommission";
import { OfferDocuments } from "./OfferDocuments/OfferDocuments";

import classes from './Offer.module.css'

// вкладка предложение
export const Offer = () => {
  return (
    <section className={classes.offerWrapper}>
      <Divider orientation="left" orientationMargin={0} className={classes.offerDivider}>
        Блок формирования предложения
      </Divider>
      <ApplicationCommission />
      <Divider />
      <OfferDocuments />
    </section>
  );
};
